import SimpleLoader from "components/Common/SimpleLoader";
import { useTranslation } from "react-i18next";

export const FallBackMessage = () => {
    const { t } = useTranslation(['translation']);
    return <SimpleLoader
            message={(<span>{t('loading')}<br/>{t('pleaseWait')}</span>)}
    />;
}
